import React from 'react';

class LiveLabel extends React.Component {
  render() {
    let classes = 'b-livelabel';
    let extraProps;
    if (this.props.video && this.props.video.timeshift) {
      classes += ' timeshift';
      extraProps = {
        title: 'Skip ahead to live broadcast',
        onClick: () => {this.props.video.timeshift = false;}
      };
    }
    return <div className={classes} {...extraProps}>Live</div>;
  }
}

export default LiveLabel;
